<template>
  <div class="form_wrapper_inner fill_form_fail">
    <template v-if="status == 'pending'">
      <h1>Pending Confirmation</h1>
      <p>Thank you for submitting your application. We will review your information and provide you with feedback via email.
        <br /> You may also log in here to see the results within 3 business days.</p>
      <p>Best,<br>The HAWO Recruitment Team</p>
    </template>

    <template v-if="status == 'failure'">
      <h1>Confirmation Result</h1>
      <p>Thank you for your application to teach with 51Talk.</p>
      <p>Unfortunately, we have decided not to move forward in the recruitment process with your application.</p>
      <p>We appreciate the time and effort you have put into applying, and wish you the best of luck in your job search.</p>
      <p>Best,<br>The HAWO Recruitment Team</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      required: true,
      default: null
    }
  }
}
</script>

<style lang="less">
.fill_form_fail {
  padding-left: 80px;

  h1 {
    padding: 50px 0 40px 0;
    font-size: 30px;
  }

  p {
    margin-bottom: 40px;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// fillform_pending.vue?2b75b6db